import {Button, Modal, Table} from "antd";
import {PlusOutlined} from "@ant-design/icons";

const ChooseFromAdminAddModal = ({dataToChoose, chooseModalShown, setChooseModalShown, fillModal, columns}) => {
  const chooseItemAction = (item) => {
    setChooseModalShown(false);
    fillModal(item);
  }

  columns = [
      ...columns,
    {
      title: 'Action',
      render: (_, record) => (
          <Button icon={<PlusOutlined />} onClick={() => chooseItemAction(record)}>
            Import
          </Button>
      )
    }

  ]

  return (
      <Modal
          getContainer={false}
          centered
          open={chooseModalShown}
          width={1300}
          title="Choose from imported items"
          footer={[]}
          onCancel={() => setChooseModalShown(false)}>
        <Table dataSource={dataToChoose} columns={columns}></Table>
      </Modal>
  )
}

export default ChooseFromAdminAddModal;